module.exports = __webpack_public_path__ + "static/media/slow-spring-board.1138fb91.mp3";